module.exports = __webpack_public_path__ + "static/media/icon-user-profile.9b0e2d8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-user-profile.svg
// module id = 1109
// module chunks = 0